import { BitrixVue } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns, NewsletterHost } from 'vpl.tas';
import { articleTables } from '../../article-tables';



export const NewsDetailPage = {
    components: {
        ItemEditBtns,
        NewsletterHost
    },
    directives: {
        articleTables
    },
    props: {
        structKey: [String, Number],
    },
    data() {
        return {
            shareObj: false
        }
    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH']),
        newsDetail() {
            return this.struct[this.structKey].componentData.ITEM;
        }
    },
    methods: {
        share(e) {
            /*
            if(this.shareObj == false){
              this.shareObj = Ya.share2($(e.target).find('.ya-share2')[0], {
                theme: {
                  services: 'vkontakte,odnoklassniki,telegram,twitter,whatsapp,pinterest',
                  size: 'm',
                  colorScheme: "whiteblack",
                  popupPosition: 'inner',
                  useLinks: true,
                  direction: 'horizontal'
                },
                content: {
                    url: window.location.origin + this.newsDetail.DETAIL_PAGE_URL,
                    title: this.newsDetail.NAME,
                    description: this.newsDetail.PREVIEW_TEXT,
                    image: window.location.origin + this.newsDetail.PREVIEW_IMAGE
                }
              });
            }
            */
            let link = $(e.target);
            if (!link.hasClass('is-active')) {
                link.addClass('is-active');
                link.find('.js-share-inner').addClass('is-open');
            } else {
                link.removeClass('is-active');
                link.find('.js-share-inner').removeClass('is-open');
            }

        },
        shareClick(e, type) {
            e.stopPropagation();

            let pageUrl = window.location.origin + window.location.pathname;
            const pageTitle = encodeURIComponent(document.title);

            switch (type) {
                case 'wa':
                    window.open(`https://wa.me/?text=${pageTitle}%20${pageUrl}`, '_blank').focus();
                    break;
                case 'tg':
                    window.open(`https://t.me/share/url?url=${pageUrl}&text=${pageTitle}`, '_blank').focus();
                    break;
                case 'vk':
                    window.open("https://vk.com/share.php?url=" + pageUrl, '_blank').focus();
                    break;
                case 'copy':

                    try {
                        navigator.clipboard.writeText(pageUrl);
                        alert('Ссылка скопирована в буфер обмена');
                    } catch (err) {
                        const textArea = document.createElement('textarea');
                        textArea.value = pageUrl;
                        document.body.appendChild(textArea);
                        textArea.select();

                        try {
                            document.execCommand('copy');
                            alert('Ссылка скопирована в буфер обмена');
                        } catch (err) {
                            alert('Не удалось скопировать ссылку');
                        }

                        document.body.removeChild(textArea);
                    }

                    break;
            }

            // window.open("https://vk.com/share.php?url=" + window.location.origin + window.location.pathname,"sharer","status=0,toolbar=0,width=650,height=500")

        },
        zoom(e) {
            $(e.target).parents('.js-news-det-slider-wp').find('.swiper-slide-active').find('a').trigger('click');
        }
    },
    mounted() {

        var mpSwiperNews = new Swiper('.js-news-det-slider', {
            loop: true,
            grabCursor: true,
            slidesPerView: 1,
            spaceBetween: 30,
            autoplay: {
                delay: 3000
            },
            pagination: {
                el: ".js-news-det-pag",
                type: "bullets",
                clickable: true
            },
            navigation: {
                nextEl: ".js-news-det-btn-next",
                prevEl: ".js-news-det-btn-prev"
            }
        });

    },
    template: `

<section class="news__detail-wp">
    <div class="container">
        <div class="news__detail">
            <div v-if="this.newsDetail" class="news__detail-date">
                <span>{{this.newsDetail.DATE.day}}</span>
                {{this.newsDetail.DATE.month}}
                <span class="news__detail-date-year">‘{{this.newsDetail.DATE.year}}</span>
            </div>
            <div class="news__detail-text content">
                <div class="projects__intra-rightside js-news-det-slider-wp">
                    <div class="projects__intra-rightside-inner">

                        <div v-if="this.newsDetail.GALLERY && this.newsDetail.GALLERY.length" class="swiper projects__intra-slider js-news-det-slider">
                            <div class="swiper-wrapper">
                                <div v-for="slide in this.newsDetail.GALLERY" class="swiper-slide">
                                    <a :href="slide.BIG" class="projects__intra-slider-img" data-fancybox="project-detail">
                                        <img :src="slide.MEDIUM" :alt="this.newsDetail.NAME" :title="this.newsDetail.NAME" loading="lazy">
                                    </a>
                                </div>
                            </div>
                        </div>

                        <a v-if="this.newsDetail.GALLERY && this.newsDetail.GALLERY.length" href="#" @click.prevent="zoom($event)" class="zoom js-news-det-zoom">
                            <svg class="icon icon-zoom"><use xlink:href="#icon-zoom"></use></svg>
                        </a>
                        <div v-if="this.newsDetail.GALLERY && this.newsDetail.GALLERY.length" class="slider-arrows">
                            <div class="swiper-button-prev slider-btn js-news-det-btn-prev">
                                <svg class="icon icon-arrow-prev"><use xlink:href="#icon-arrow-prev"></use></svg>
                            </div>
                            <div class="swiper-button-next slider-btn js-news-det-btn-next">
                                <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-pagination js-news-det-pag"></div>
                </div>
                <div v-article-tables v-html="this.newsDetail.TEXT"></div>
            </div>

            <div class="news__detail-share">
                <div class="product-detail__share js-share" @click="share($event)">
                    <svg class="icon icon-share"><use xlink:href="#icon-share"></use></svg>
                    Поделиться
                    <div class="product-detail__share-inner js-share-inner">
                        <a class="product-detail__share-inner-item"
                                @click.prevent="shareClick($event, 'wa')"
                                title="">
                                <svg class="ico ico-wa" width="24" height="24" aria-hidden="true"><use xlink:href="#ico-wa"></use></svg>
                        </a>
                        <a class="product-detail__share-inner-item"
                                @click.prevent="shareClick($event, 'tg')"
                                title="">
                                <svg class="ico ico-tg" width="24" height="24" aria-hidden="true"><use xlink:href="#ico-tg"></use></svg>
                        </a>
                        <a class="product-detail__share-inner-item"
                                @click.prevent="shareClick($event, 'vk')"
                                title="">
                                <svg class="ico ico-vk" width="24" height="24" aria-hidden="true"><use xlink:href="#ico-vk"></use></svg>
                        </a>
                        <a class="product-detail__share-inner-item"
                                @click.prevent="shareClick($event, 'copy')"
                                title="">
                                <svg class="ico ico-copy" width="24" height="24" aria-hidden="true"><use xlink:href="#ico-copy"></use></svg>
                        </a>
                    </div>
                </div>
            </div>


        </div>

        <!-- SAIT-135: отдельная строка вне колонок даты, статьи и кнопки «Поделиться». -->
        <NewsletterHost :key="newsDetail.ID" source="news" variant="article" />
    </div>
</section>
    `
}